import { render, staticRenderFns } from "./PlatPurchaseOrderDetailModal.vue?vue&type=template&id=404a51ad&scoped=true"
import script from "./PlatPurchaseOrderDetailModal.vue?vue&type=script&lang=ts"
export * from "./PlatPurchaseOrderDetailModal.vue?vue&type=script&lang=ts"
import style0 from "./PlatPurchaseOrderDetailModal.vue?vue&type=style&index=0&id=404a51ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404a51ad",
  null
  
)

export default component.exports